export const getRootNode = () => document.getElementById('react-root')
